/* =========================================================================
   Kitsters floating UI - global, loaded via kitsters-footer.liquid
   Covers: exit-intent modal, FAB wiggle
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- exit-intent (desktop) / scroll-up (mobile) ---------- */
  function initExitIntent() {
    var modal = document.querySelector('[data-exit]');
    if (!modal) return;
    var KEY = 'kitsters-exit-shown';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}

    var closes = modal.querySelectorAll('[data-exit-close]');
    var pageLoaded = Date.now();
    var triggered = false;

    function show() {
      if (triggered) return;
      if (Date.now() - pageLoaded < 12000) return; // only after 12s on page
      triggered = true;
      modal.classList.add('is-open');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    }
    function hide() { modal.classList.remove('is-open'); }
    closes.forEach(function (c) { c.addEventListener('click', hide); });
    modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

    // desktop: mouse leaves viewport top
    document.addEventListener('mouseout', function (e) {
      if (e.clientY < 6 && !e.relatedTarget) show();
    });

    // mobile: detect fast scroll-up
    var lastY = window.scrollY, lastT = Date.now();
    document.addEventListener('scroll', function () {
      var now = Date.now();
      var dy = window.scrollY - lastY;
      var dt = now - lastT;
      if (dy < -120 && dt < 300 && window.scrollY < 200) show();
      lastY = window.scrollY; lastT = now;
    }, { passive: true });
  }

  /* ---------- FAB wiggle after 30s (then every 45s) ---------- */
  function initFabWiggle() {
    var fab = document.querySelector('.fab');
    if (!fab) return;
    function wiggle() {
      fab.classList.remove('is-wiggle');
      void fab.offsetWidth; // force reflow so animation replays
      fab.classList.add('is-wiggle');
      fab.addEventListener('animationend', function () {
        fab.classList.remove('is-wiggle');
      }, { once: true });
    }
    setTimeout(function () {
      wiggle();
      setInterval(wiggle, 45000);
    }, 30000);
  }

  function boot() {
    initExitIntent();
    initFabWiggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
